import { actions as uiActions } from 'state/ui';

export const showTemporallyFeedback = (
  dispatch,
  { feedback, success, params },
  timeout = 10000
) => {
  dispatch(
    uiActions.setFeedback({
      feedback,
      success,
      params,
    })
  );
  setTimeout(() => {
    dispatch(
      uiActions.setFeedback({
        feedback: null,
      })
    );
  }, timeout);
};
